import * as React from 'react';
import moment from 'moment';

import DatePickerMulti from 'components/date-picker/date-picker-multi/DatePickerMultiLazy';

import DiscoveryFiltersTitle from 'modules/discovery/components/filters/title/DiscoveryFiltersTitle';

import { __t, applyTranslations } from 'utils/language';

import './discovery-content-filters-timeframe.scss';

import type { DiscoveryContentFilters } from 'types';

applyTranslations(require('./discovery-content-filters-timeframe.i18n.json'));

type Props = {
  filters: DiscoveryContentFilters,
  handleFiltersUpdate: (a: any) => void
};

const msgKey = 'discovery_content_filters_timeframe';

class DiscoveryContentFiltersTimeframe extends React.PureComponent<Props> {
  static defaultProps = {
    filters: {},
    handleFiltersUpdate: () => {}
  };

  handleTimeframeChange = (startDate?: string | null, endDate?: string | null): void => {
    this.handleUpdate({
      timeframe: {
        startDate,
        endDate
      }
    });
  };

  handleUpdate = (result: any): void => {
    const { handleFiltersUpdate } = this.props;

    if (handleFiltersUpdate) {
      handleFiltersUpdate(result);
    }
  };

  renderTimeframe(): React.ReactNode {
    const { filters } = this.props;
    const timeframe = filters.timeframe;
    const isInvalidTimeframe = timeframe.startDate && moment(timeframe.startDate).isBefore('2019-01-01');

    return (
      <div className="discovery-content-filters-timeframe__section">
        <DiscoveryFiltersTitle
          title={__t(`${msgKey}.labels.timeframe`)}
        />
        <DatePickerMulti
          startDateName="startDate"
          startDate={timeframe.startDate}
          endDateName="endDate"
          endDate={timeframe.endDate}
          minAllowableDate="2019-01-01"
          noPastDates={false}
          numMonths={1}
          noFutureDates
          showDateSelector
          onChange={this.handleTimeframeChange}
        />
        {isInvalidTimeframe && (
          <div className="discovery-content-filters-timeframe__error">
            {__t('discovery_content_filters_timeframe.labels.start_date_error')}
          </div>
        )}
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="discovery-content-filters-timeframe">
        {this.renderTimeframe()}
      </div>
    );
  }
}

export default DiscoveryContentFiltersTimeframe;
